import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { language } from "../../language/Language";

const Footer = () => {
  const isArabic = language === "ar";

  // كل ألوان النصوص بتتبع المتغير بدل Tailwind الـ hardcoded
  const textStyle   = { color: "var(--footer-text-color, #ffffff)" };
  const mutedStyle  = { color: "var(--footer-text-color, #ffffff)", opacity: 0.75 };

  return (
    <footer
      className="py-14 font-sans tracking-wide text-sm"
      style={{
        backgroundColor: "var(--footer-bg-color, #111827)",
        color: "var(--footer-text-color, #ffffff)",
      }}
    >
      <div className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {/* Important Links */}
        <div>
          <h2 className="text-lg font-semibold mb-4" style={textStyle}>
            {isArabic ? "روابط مهمة" : "Important Links"}
          </h2>
          <ul className="space-y-4">
            <li>
              <Link to="/Products" className="transition hover:opacity-100" style={mutedStyle}>
                {isArabic ? "منتجاتنا" : "Our Products"}
              </Link>
            </li>
            <li>
              <Link to="/FeaturedProducts" className="transition hover:opacity-100" style={mutedStyle}>
                {isArabic ? "المنتجات المميزة" : "Featured Products"}
              </Link>
            </li>
            <li>
              <Link to="/Brands" className="transition hover:opacity-100" style={mutedStyle}>
                {isArabic ? "الشركات (كل الشركات)" : "Companies (All companies)"}
              </Link>
            </li>
          </ul>
        </div>

        {/* Help Section */}
        <div>
          <h2 className="text-lg font-semibold mb-4" style={textStyle}>
            {isArabic ? "هل تحتاج إلى مساعدة؟" : "Need Help?"}
          </h2>
          <ul className="space-y-4">
            <li>
              <a href="mailto:admin@meat-house.online" className="transition hover:opacity-100" style={mutedStyle}>
                admin@meat-house.online
              </a>
            </li>
            <li>
              <a
                href="https://api.whatsapp.com/send?phone=2001143837483"
                target="_blank"
                rel="noopener noreferrer"
                className="transition hover:opacity-100"
                style={mutedStyle}
              >
                {isArabic ? "الهاتف: " : "Phone: "}+20 01143837483
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Divider */}
      <hr className="my-8" style={{ borderColor: "var(--footer-text-color, #6b7280)", opacity: 0.3 }} />

      {/* Footer Bottom */}
      <div className="container flex flex-col sm:flex-row justify-between items-center gap-6">
        {/* Social Icons */}
        <div className="flex gap-4">
          {[
            {
              icon: faFacebook,
              url: "https://www.facebook.com/Meat.House.Alfardos?mibextid=ZbWKwL",
              color: "#3b5998",
            },
          ].map((social, idx) => (
            <a
              key={idx}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform hover:scale-110"
            >
              <FontAwesomeIcon icon={social.icon} size="3x" color={social.color} />
            </a>
          ))}
        </div>

        {/* Copyright */}
        <p className="text-sm text-center sm:text-right" style={mutedStyle}>
          {isArabic
            ? `© ${new Date().getFullYear()} جميع الحقوق محفوظة لدى Meat-house El-Fardos.`
            : `© ${new Date().getFullYear()} All rights reserved to Meat-house El-Fardos.`}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
